import MNewInvitationLinkDialog from './MNewInvitationLinkDialog.vue';

export { MNewInvitationLinkDialog };
export default MNewInvitationLinkDialog;
